import React from 'react';
import { Layout } from '../components/Layout';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { StatsSection } from '../components/StatsSection';
import { ReframeSection } from '../components/ReframeSection';
import { AnimatedStatsSection } from '../components/AnimatedStatsSection';
import { InfoSection } from '../components/InfoSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
import { ParallaxSection } from '../components/ParallaxSection';
export function LandingPage() {
  return <Layout data-id="element-121">
      <Header data-id="element-122" />
      <main data-id="element-123">
        <Hero data-id="element-124" />

        <StatsSection data-id="element-125" />

        <ReframeSection data-id="element-126" />

        <AnimatedStatsSection data-id="element-127" />

        <InfoSection title="Manual workflows collect patient samples, but they are fragmented, slow, and costly." description="What if researchers could find, match and access samples 8x faster?" data-id="element-128" />

        <InfoSection title="Not only is it possible, it's happening now, more safe and securely than ever." description="Sensitive patient info stays secure local at the hospital, so now your research can go global." highlight align="center" data-id="element-129" />

        <FeaturesSection data-id="element-130" />

        <section className="h-[1024px] px-4 text-center flex items-center justify-center overflow-hidden" data-id="element-131">
          <ParallaxSection speed={0.3} data-id="element-132">
            <div className="max-w-4xl mx-auto" data-id="element-133">
              <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#a1da52]" data-id="element-134">
                Why Now
              </h2>
              <p className="text-xl text-white/80" data-id="element-135">
                Enabling researchers to find and access the right biospecimens
                in days, reducing months of delay and millions in operational
                costs through a federated hospital network powered by automation
                and AI.
              </p>
            </div>
          </ParallaxSection>
        </section>

        <ContactForm data-id="element-136" />
      </main>
      <Footer data-id="element-137" />
    </Layout>;
}